import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, Sun } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/billing/checkout/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") { setStatus("success"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-solar-bg text-zinc-900 flex items-center justify-center p-6">
      <div className="bg-white border border-zinc-200/70 rounded-3xl p-10 max-w-md w-full text-center">
        <div className="w-12 h-12 mx-auto rounded-xl bg-zinc-900 flex items-center justify-center text-white mb-5"><Sun size={24}/></div>
        {status === "checking" && (<><Loader2 className="mx-auto text-amber-600 animate-spin mb-3" size={32}/><h1 className="text-2xl font-bold">Verifica pagamento…</h1><p className="text-zinc-500 mt-2 text-sm">Non chiudere questa pagina</p></>)}
        {status === "success" && (<><CheckCircle2 className="mx-auto text-emerald-600 mb-3" size={48}/><h1 className="text-2xl font-bold">Pagamento riuscito!</h1><p className="text-zinc-500 mt-2 text-sm">Il tuo piano è stato attivato.</p>{data && <div className="mt-3 font-mono text-sm text-amber-600">€ {(data.amount_total/100).toFixed(2)} {data.currency?.toUpperCase()}</div>}<Link to="/app/dashboard" className="mt-6 inline-block bg-zinc-900 text-white font-semibold rounded-xl px-6 py-3 text-sm">Vai alla dashboard</Link></>)}
        {(status === "expired" || status === "error" || status === "timeout") && (<><h1 className="text-2xl font-bold">Qualcosa è andato storto</h1><p className="text-zinc-500 mt-2 text-sm">Riprova dalla pagina impostazioni.</p><Link to="/app/settings" className="mt-6 inline-block border border-zinc-200/70 rounded-xl px-6 py-3 text-sm">Torna alle impostazioni</Link></>)}
      </div>
    </div>
  );
}
